import { cn } from '@worldcoo/ui/lib/utils';

function extractYouTubeVideoId(url: string): string | null {
	try {
		const parsed = new URL(url);

		if (parsed.hostname === 'youtu.be') return parsed.pathname.slice(1) || null;
		if (parsed.hostname.includes('youtube.com')) {
			if (parsed.pathname.startsWith('/embed/')) {
				return parsed.pathname.replace('/embed/', '') || null;
			}

			if (parsed.pathname.startsWith('/shorts/')) {
				return parsed.pathname.replace('/shorts/', '') || null;
			}

			return parsed.searchParams.get('v');
		}
	} catch {
		// invalid URL
	}

	return null;
}

export function YouTubeEmbed(props: { url: string; title?: string; className?: string }) {
	const videoId = extractYouTubeVideoId(props.url);
	if (!videoId) return null;

	return (
		<div className="flex h-full items-center justify-center">
			{/* oxlint-disable-next-line react/iframe-missing-sandbox */}
			<iframe
				src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&controls=0`}
				title={props.title ?? 'Campaign video'}
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
				className={cn('aspect-video w-full', props.className)}
			/>
		</div>
	);
}
